import { toLocaleCurrencyString } from '@/lib/toLocaleCurrencyString';
import type { Price } from '@/types';
import { useTranslation } from 'react-i18next';

type Props = {
  price?: Price;
};

export const PromotionPrice = ({ price }: Props) => {
  const { t } = useTranslation();

  if (!price?.promotionCodeId) return null;

  return (
    <div className="mt-4 rounded-xl bg-gradient-to-r from-pink-50 to-pink-100 px-8 py-4">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs font-medium uppercase tracking-wider text-pink-800">
            {t('プロモーションコード適用済み')}
          </div>
          <div className="mt-1 flex items-baseline">
            <span className="text-sm text-gray-500 line-through">
              {toLocaleCurrencyString(
                price.displayAmountMonthly,
                price.currency
              )}
            </span>
            <span className="ml-4 text-2xl font-bold text-pink-700">
              {toLocaleCurrencyString(
                price.displayAmountDiscountedMonthly,
                price.currency
              )}
              <span className="ml-1 text-base">/ {t('月')}</span>
            </span>
          </div>
        </div>
        <div className="rounded-full bg-pink-200 px-3 py-1 text-sm font-medium text-pink-800">
          {price.displayDiscountAmountLabel} {t('割引')}
        </div>
      </div>
    </div>
  );
};
